import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use((r) => r, async (error) => {
  if (error.response?.status === 403 && error.response?.data?.code === "password_change_required" && !window.location.pathname.startsWith("/admin/change-password")) { window.location.href = "/admin/change-password"; return Promise.reject(error); }
  if (error.response?.status === 403 && error.response?.data?.code === "training_required") {
    toast.error(error.response.data.detail, { id: "training-required", duration: 9000, action: { label: "Open training", onClick: () => { window.location.href = "/portal/training"; } } });
  }
  const detail = error.response?.data?.detail || "";
  const cfg = error.config || {};
  if (error.response?.status === 423 && typeof detail === "string" && detail.includes("amendment reason") && !cfg._amendRetried) {
    const reason = window.prompt("This record is approved and locked.\nEnter the reason for this amendment (it will be versioned, audited and sent back for approval):");
    if (reason && reason.trim().length >= 5) {
      cfg._amendRetried = true;
      cfg.headers = { ...(cfg.headers || {}), "X-Amendment-Reason": reason.trim() };
      return api.request(cfg);
    }
  }
  return Promise.reject(error);
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
